import { render, staticRenderFns } from "./MSelect.vue?vue&type=template&id=8598e42c&"
import script from "./MSelect.ts?vue&type=script&lang=ts&"
export * from "./MSelect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports